import React, { useState } from 'react';
import './Deposit.css';
import { authService } from '../services/authService';

const ChangePassword = () => {
  const user = authService.getCurrentUser();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!password || password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (!user?.mobile && !user?.mobile_no) {
      setError('Mobile number not found');
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        'https://playinbyd.com/api/api-change-password-mpin',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
            env_type: 'Prod',
            password,
            mobile: user.mobile || user.mobile_no
          })
        }
      );

      const data = await res.json();

      if (data.success) {
        setSuccess('Password changed successfully');
        setPassword('');
        setConfirmPassword('');
      } else {
        setError(data.msg || 'Failed to change password');
      }
    } catch (err) {
      console.error(err);
      setError('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bet-history-page">
      <div className="deposit-page">
        <div className="main-card">

          {/* HEADER */}
          <div className="main-card-header">
            <h1 className="page-title">Change Password</h1>
            <p className="page-subtitle">
            </p>
          </div>

          {/* FORM */}
          <form className="deposit-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password *</label>
              <input
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Confirm Password *</label>
              <input
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? 'Updating...' : 'Change Password'}
            </button>

            {error && <div className="error">{error}</div>}
            {success && <div className="success">{success}</div>}
          </form>

        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
